import axios from "axios";

/** Пауза для ретраев bootstrap / ожидания TG SDK. */
export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Ошибка, после которой можно смело считать пользователя гостем (нет/протухла сессия).
 * Сетевые сбои и 5xx — нет: иначе юзер периодически видит экран логина при живых cookies.
 */
export const isDefinitiveAuthFailure = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) return false;
  const status = error.response?.status;
  return status === 401 || status === 403;
};

/** Временный сбой: нет ответа, таймаут, 5xx. */
export const isTransientRequestError = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) return true;
  if (!error.response) return true;
  const status = error.response.status;
  return status >= 500 && status <= 599;
};

/**
 * Несколько попыток при временных ошибках. На 401/403 сразу пробрасываем.
 */
export async function withTransientRetry<T>(
  fn: () => Promise<T>,
  attempts = 3,
  baseDelayMs = 400
): Promise<T> {
  let lastError: unknown;
  for (let i = 0; i < attempts; i++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (isDefinitiveAuthFailure(error)) throw error;
      if (!isTransientRequestError(error) && i === 0) {
        // Неожиданный 4xx (не auth) — один повтор не поможет.
        throw error;
      }
      if (i < attempts - 1) {
        await sleep(baseDelayMs * (i + 1));
      }
    }
  }
  throw lastError;
}
